import { RefObject } from "react";
import { Editor as EditorRef } from "@tinymce/tinymce-react";
import { Box, Button } from "@mui/material";
import { ReactComponent as ClearTagsIcon } from "assets/icons/clear-tags-icon.svg";
import { SSMLTag } from "shared/constants";
import { useSSMLTagRemover } from "shared/hooks/useSSMLTag";
import { useTranslation } from "react-i18next";

interface MenuWrapperProps {
  id: string;
  children?: React.ReactNode;
  showDeleteButton: boolean;
  editorRef: RefObject<EditorRef | null>;
  tagType: SSMLTag;
  onApply?: () => void;
}

export default function MenuWrapper({
  id,
  children,
  showDeleteButton = false,
  editorRef,
  tagType,
  onApply,
}: MenuWrapperProps): JSX.Element {
  const removeSSMLTag = useSSMLTagRemover(editorRef);
  const { t } = useTranslation();

  const handleDelete = () => {
    if (showDeleteButton) {
      removeSSMLTag(tagType);
    }
    onApply?.();
  };

  return (
    <Box id={id}>
      {children}
      {(showDeleteButton || onApply) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "16px 16px 8px",
          }}
        >
          {showDeleteButton && (
            <Button
              endIcon={<ClearTagsIcon />}
              onClick={handleDelete}
              color="error"
              variant="outlined"
              size="large"
              fullWidth
            >
              {t("buttons.clearTags")}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
}
